'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["highlights", "size", "spacing"];
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import CsatHappy from './CsatHappy';
import CsatNeutral from './CsatNeutral';
import CsatSad from './CsatSad';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RatingComponents = [CsatSad, CsatNeutral, CsatHappy];
class CsatRating extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      value: undefined
    };
    this.getValue = () => {
      const {
        value: pValue
      } = this.props;
      const {
        value: sValue
      } = this.state;
      // can't short circuit w/ or b/c 0 is valid and falsy
      return pValue === undefined ? sValue : pValue;
    };
    this.handleSelect = rating => () => {
      const {
        onChange
      } = this.props;
      const previous = this.getValue();
      this.setState({
        value: rating
      });
      if (onChange && rating !== previous) {
        onChange(rating);
      }
    };
    this.renderRatingIcon = value => {
      const _this$props = this.props,
        {
          highlights,
          size,
          spacing
        } = _this$props,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded);
      const selected = this.getValue() === value;
      const RatingComponent = RatingComponents[value];
      return /*#__PURE__*/_jsx("span", Object.assign({
        style: {
          borderLeft: `${value === 0 ? 0 : spacing}px solid transparent`,
          display: 'inline-block',
          lineHeight: 0
        }
      }, props, {
        children: /*#__PURE__*/_jsx(RatingComponent, {
          "data-selenium-test": `rating-${value}`,
          highlights: highlights,
          onClick: this.handleSelect(value),
          selected: selected,
          size: size
        })
      }));
    };
    this.render = () => /*#__PURE__*/_jsxs("div", {
      "data-selenium-test": "feedback-rating-csat",
      "data-test-id": "feedback-rating-csat",
      style: {
        display: 'inline-block'
      },
      children: [this.renderRatingIcon(0), this.renderRatingIcon(1), this.renderRatingIcon(2)]
    });
  }
}
CsatRating.defaultProps = {
  highlights: true,
  size: 60,
  spacing: 0
};
CsatRating.propTypes = {
  highlights: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.number,
  spacing: PropTypes.number,
  value: PropTypes.number
};
export default CsatRating;